import {Priority} from "../api/issue.ts";
import {FC} from "react";

interface Props {
    priority: Priority
}

const ACTIVE_COLORS: Record<string, string> = {
    CRITICAL: '#EF4444',
    HIGH:'#F59E0B',
    MEDIUM: '#F59E0B',
    LOW: '#F59E0B'
}

const inactiveColor = '#595959';

const PriorityCircle: FC<Props> = ({ priority }) => {
    const activeColor = ACTIVE_COLORS[priority.id]
    const segment1Color = priority.id === 'CRITICAL' ? activeColor : inactiveColor;
    const segment2Color = ['HIGH', 'CRITICAL'].includes(priority.id) ? activeColor : inactiveColor;
    const segment3Color = ['MEDIUM', 'HIGH', 'CRITICAL'].includes(priority.id) ? activeColor : inactiveColor;

    return <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.52344 2.75977C4.65677 3.65143 2.44844 6.05144 1.8401 9.03477" stroke={segment1Color} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.8487 2.42578C15.057 2.85078 18.332 6.40078 18.332 10.7174C18.332 15.0341 15.0487 18.5841 10.8487 19.0091" stroke={segment3Color} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.83438 12.3926C2.44271 15.3676 4.62604 17.7592 7.48437 18.6676" stroke={segment2Color} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
}

export default PriorityCircle;